<template lang="pug">
  #account-view.body: .body-inner
    form(@submit.prevent="validateSelf" novalidate)
      UiFormField(
        v-model="emailModel"
        v-validate="form.email.rules"
        v-bind="form.email.params"
        :error="errors.first(form.email.params.name)"
      )
      UiFormField(
        v-model="passwordModel"
        v-validate="form.password.rules"
        v-bind="form.password.params"
        :error="errors.first(form.password.params.name)"
      )
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'Account',
  // Created -------------------------------------------------------------------
  created () {
    this.SET_CURRENT_VIEW({ vm: this })
  },
  // Data ----------------------------------------------------------------------
  data () {
    return {
      form: {
        email: {
          rules: {
            required: true,
            email: true
          },
          params: {
            name: 'email',
            type: 'email',
            label: 'Email'
          }
        },
        password: {
          rules: {
            required: true,
            min: 8
          },
          params: {
            name: 'password',
            type: 'password',
            label: 'Придумайте пароль',
            toggle: true
          }
        }
      }
    }
  },
  // Computed ------------------------------------------------------------------
  computed: {
    // Vuex map getters of the User SM
    ...mapGetters('moduleUser', [
      'getUserData'
    ]),
    // Email model
    emailModel: {
      get () { return this.getUserData.email },
      set (v) { this.SET_USER_DATA_FIELD({ f: 'email', v }) }
    },
    // Password model
    passwordModel: {
      get () { return this.getUserData.password },
      set (v) { this.SET_USER_DATA_FIELD({ f: 'password', v }) }
    },
    // Robot message
    robotMessage () {
      const branded = this.$store.state.config.branded
      if (branded === 'anderida') return 'В первую очередь предлагаем создать персональную учетную запись на клиентском портале Anderida Financial Group.'
      if (branded === 'ds') return 'В первую очередь предлагаем создать персональную учетную запись на клиентском портале DS Consulting.'
      if (branded === 'scapital') return 'В первую очередь предлагаем создать персональную учетную запись на клиентском портале Smirnova Capital.'
      return 'Настройка параметров защиты цифрового профиля от несанкционированного доступа.'
    }
  },
  // Methods -------------------------------------------------------------------
  methods: {
    // Vuex map mutations of the User SM
    ...mapMutations('moduleUser', [
      'SET_USER_DATA_FIELD'
    ]),
    // Vuex map mutations of the Wizard SM
    ...mapMutations('moduleWizard', [
      'SET_CURRENT_VIEW',
      'SET_NAV_FIELD'
    ]),
    // Vuex map actions of the User SM
    ...mapActions('moduleUser', [
      'checkUserEmail'
    ]),
    // Vuex map actions of the Security SM
    ...mapActions('moduleSecurity', [
      'sendMessage'
    ]),
    // Self back validator
    async backSelf () {
      return true
    },
    // Self next validator
    async nextSelf () {
      // If all is fine => true, else => false
      const res = await this.$validator.validate()
        .then(async result => {
          if (!result) return false // some frontend errors
          const { status, errors } = await this.checkUserEmail()
          if (status) {
            this.sendMessage({ e: 'AccountComplete' })
            return true
          }
          if ('fields' in errors) {
            for (const field in errors.fields) {
              this.errors.add({ field, msg: errors.fields[field][0] })
            }
          } else {
            this.SET_NAV_FIELD({ f: 'errorTextNext', v: errors.global[0] })
          }
          return false
        })
      return res
    }
  }
}
</script>
